import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b99efa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "max-w-screen-xl mx-auto" }
const _hoisted_4 = { class: "flex flex-wrap -mx-4" }
const _hoisted_5 = { class: "w-full lg:w-1/4 px-3" }
const _hoisted_6 = { class: "mb-5" }
const _hoisted_7 = { class: "card w-75 shadow-xl" }
const _hoisted_8 = { class: "card-body items-center text-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Image Web", -1))
const _hoisted_10 = { class: "mb-5" }
const _hoisted_11 = { class: "card w-75 shadow-xl" }
const _hoisted_12 = { class: "card-body items-center text-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Image Mobile", -1))
const _hoisted_14 = { class: "w-full lg:w-3/4 px-4" }
const _hoisted_15 = { class: "card w-full shadow-xl" }
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = {
  key: 0,
  class: "formkit-label"
}
const _hoisted_19 = {
  key: 1,
  class: "formkit-label"
}
const _hoisted_20 = { class: "formkit-label" }
const _hoisted_21 = { class: "formkit-label" }
const _hoisted_22 = { class: "formkit-label" }
const _hoisted_23 = {
  key: 2,
  class: "formkit-label"
}
const _hoisted_24 = { class: "card-actions" }
const _hoisted_25 = { key: 0 }

import { onBeforeMount, ref } from 'vue';
import { useRoute } from 'vue-router';
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import { useRouter } from "vue-router";
import UploadImage from "@/components/forms/UploadImage.vue";
import {IMiddleMenuItem} from "@/models/homepage/IMiddleMenuItem";
import {fetchMiddleMenuItemByUuid} from "@/_services/homepage/middleMenuItem";
import { getItemTypeOptions } from '@/_services/homepage/itemTypeServices.ts'; 

const submitBtnLabel = 'éditer';

export default /*#__PURE__*/_defineComponent({
  __name: 'EditMiddleMenuItem',
  setup(__props) {

const title = ref<string>("Editer un encart ");
const middleMenuItem = ref<IMiddleMenuItem>({} as IMiddleMenuItem);
const route = useRoute();
const uuidRouteParam = ref<string>("");
const uuidMiddleMenu = ref<string>("");
const router = useRouter();
const loading = ref<boolean>(true);
const filledFieldCount = ref<number>(0);
const itemTypeOptions = getItemTypeOptions();
const blockType = route.params.blockType;
let validationLabel = 'contains_alpha|matches:/^[^/]*$/|length:0,15';
let validationLabelMessageLength = 'Ce champ doit contenir au maximum 15 caractères';
if (blockType === 'travel') {
    validationLabel = 'contains_alpha|matches:/^[^/]*$/|length:0,30';
    validationLabelMessageLength = 'Ce champ doit contenir au maximum 30 caractères';
}

onBeforeMount(async () => {
    loading.value = true;
    uuidRouteParam.value = route.params.uuid.length ? route.params.uuid as string : "";
    
    if (uuidRouteParam.value.length) {
        middleMenuItem.value = await fetchMiddleMenuItemByUuid(uuidRouteParam.value);
        await hydrateForm(middleMenuItem.value);


        loading.value = false;
    }

    
});

const form = ref<IMiddleMenuItem>({
    title: null,
    position: null,
    label: null,
    description: null,    
    imageWeb: null,
    imageMobile: null,   
    filter: undefined,
    redirectionLink: undefined,

    itemType: null,
    itemValue: null,
    middleMenu : null,
});

const hydrateForm = (middleMenuItem: IMiddleMenuItem) => {
    form.value = {
        title: middleMenuItem.title,
        position: middleMenuItem.position,       
        label: middleMenuItem.label,
        description: middleMenuItem.description,
        imageWeb: middleMenuItem.imageWeb,
        imageMobile: middleMenuItem.imageMobile,        
        filter: middleMenuItem.filter,
        redirectionLink: middleMenuItem.redirectionLink,
        
        itemValue: middleMenuItem.itemValue,
        itemType: middleMenuItem.itemType,
        middleMenu: middleMenuItem.middleMenu,
    }
}

const onSubmit = async (formData) => {
    try {
        if (null == form.value.imageWeb || null == form.value.imageMobile) {
            swal.warning('Les deux images sont obligatoires.');
            return false;
        }

        filledFieldCount.value = 0;
        if (formData.itemValue !== '' && formData.itemValue !== undefined) {
            filledFieldCount.value++;
        }

        if (formData.filter !== '' && formData.filter !== undefined) {
            filledFieldCount.value++;
        }

        if (formData.redirectionLink !== '' && formData.redirectionLink !== undefined) {
            filledFieldCount.value++;
        }

        if(filledFieldCount.value != 1) {
            swal.error("Uniquement un des 2 champs Uuid ou le champ URL de redirection doit être rempli");
            return false;
        }

        const payload = {
            title: formData.title,
            position: parseInt(formData.position),
            itemType: parseInt(formData.itemType),
            label: formData.label,
            description: formData.description,
            itemValue: formData.itemValue,
            middleMenu: formData.middleMenu,
            redirectionLink: formData.redirectionLink !== '' && formData.redirectionLink !== undefined ? formData.redirectionLink : null,
            imageWeb: null !== form.value.imageWeb ? `${form.value.imageWeb.uuid}` : null,
            imageMobile: null !== form.value.imageMobile ? `${form.value.imageMobile.uuid}` : null
        }
        
        swal.confirm(`Êtes-vous sûr de vouloir ${submitBtnLabel} ?`,
            "Annuler",
            submitBtnLabel
        )
            .then((results) => results.isConfirmed && update(payload))
    } catch (err: any) {
        swal.error(err.errors[0]);
    }
}

const update = (data) => {
    if(uuidRouteParam.value.length) {
        ApiService.patch('middle_menu_items', uuidRouteParam.value, data)
            .then(() => {
                loading.value = false;
                swal.info("Editer avec succès")
                    .then((result) => {
                        
                        if (result.isConfirmed) {
                            router.go(-1);
                        }
                    });
            })
            .catch((axiosError) => {
                swal.error("Une erreur est survenue lors de la modification");
                axiosError.response.data.errors.forEach((error) => {
                    if (error.message.startsWith("Item not found for")
                        || error.message.startsWith("Could not convert database value")) {
                        swal.error("Une erreur est survenue au moment de la modification, l’uuid ajoutée n’existe pas.");
                        return false;
                    }
                });
            });
    }
}

const onCancel = () => {
    swal.confirm(
        "Êtes-vous sûr de vouloir annuler l'édition ?",
        "Oui",
        "Non"
    ).then((result) => {
        if (result.isDismissed) {
            router.go(-1);
        }
    });
}

const onImageWebUpload = (image) => {
    form.value.imageWeb = image;
}

const onImageMobileUpload = (image) => {
    form.value.imageMobile = image;
}

const onImageWebRemoved = () => {
    form.value.imageWeb = null;
}

const onImageMobileRemoved = () => {
    form.value.imageMobile = null;
}

const onImageUploadError = (errorMsg: string) => {
    swal.error(errorMsg);
}

function getBaseUrl() {
    return window.location.origin;
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(title.value), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(UploadImage, {
                  "image-preview-url": form.value.imageWeb ? form.value.imageWeb.url : getBaseUrl() + '/media/blank2.png',
                  onImageRemoved: onImageWebRemoved,
                  onImageUploaded: onImageWebUpload,
                  onError: onImageUploadError
                }, null, 8, ["image-preview-url"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(UploadImage, {
                  "image-preview-url": form.value.imageMobile ? form.value.imageMobile.url : getBaseUrl() + '/media/blank2.png',
                  onImageRemoved: onImageMobileRemoved,
                  onImageUploaded: onImageMobileUpload,
                  onError: onImageUploadError
                }, null, 8, ["image-preview-url"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_FormKit, {
                  type: "form",
                  actions: false,
                  model: form.value,
                  onSubmit: onSubmit,
                  "outer-class": "w-full",
                  "incomplete-message": "Veuillez remplir tous les champs correctement"
                }, {
                  default: _withCtx(({ state: { valid } }) => [
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "title",
                      label: "Titre *",
                      modelValue: form.value.title,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.title) = $event)),
                      validation: "required|contains_alpha|matches:/^[^/]*$/|length:0,35",
                      "validation-messages": {
                                        required: 'Ce champ est obligatoire.',
                                        contains_alpha: 'Ce champ doit contenir des lettres..',
                                        matches: 'Ce champ ne peut contenir de “/”.',
                                        length: 'Ce champ doit contenir au maximum 35 caractères'
                                    }
                    }, null, 8, ["modelValue", "validation-messages"]),
                    _createVNode(_component_FormKit, {
                      type: "number",
                      name: "position",
                      label: "Position *",
                      modelValue: form.value.position,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.position) = $event)),
                      validation: "required|min:1",
                      "validation-messages": {
                                        required: 'Ce champ est obligatoire.',
                                        min: 'Ce champ doit être un nombre décimal superieur à 0',
                                    }
                    }, null, 8, ["modelValue", "validation-messages"]),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "label",
                      label: "Label",
                      modelValue: form.value.label,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.label) = $event)),
                      validation: _unref(validationLabel),
                      "validation-messages": {
                                            required: 'Ce champ est obligatoire.',
                                            contains_alpha: 'Ce champ doit contenir des lettres..',
                                            matches: 'Ce champ ne peut contenir de “/”.',
                                            length: _unref(validationLabelMessageLength)
                                        }
                    }, null, 8, ["modelValue", "validation", "validation-messages"]),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "description",
                      modelValue: form.value.description,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.description) = $event)),
                      label: "Description",
                      validation: "contains_alpha|matches:/^[^/]*$/|length:0,80",
                      "validation-messages": {
                                            required: 'Ce champ est obligatoire.',
                                            contains_alpha: 'Ce champ doit contenir des lettres..',
                                            matches: 'Ce champ ne peut contenir de “/”.',
                                            length: 'Ce champ doit contenir au maximum 80 caractères'
                                        }
                    }, null, 8, ["modelValue", "validation-messages"]),
                    _createVNode(_component_FormKit, {
                      type: "select",
                      label: "Type *",
                      name: "itemType",
                      modelValue: form.value.itemType,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.itemType) = $event)),
                      options: _unref(itemTypeOptions),
                      validation: "required",
                      "validation-messages": {
                                        required: 'Ce champ est obligatoire.'
                                    }
                    }, null, 8, ["modelValue", "options", "validation-messages"]),
                    (form.value.itemType === '1' || 
                                            form.value.itemType === '2' || 
                                            form.value.itemType === '5')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_18, " Uuid "))
                      : _createCommentVNode("", true),
                    (form.value.itemType === '4')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_19, "Lien de redirection"))
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("label", _hoisted_20, "Si lien de redirection type voyage, veuillez vous assurer de mettre un de ces formats: ", 512), [
                      [_vShow, form.value.itemType === '4']
                    ]),
                    _withDirectives(_createElementVNode("label", _hoisted_21, "https://app.club-employes.com/voyage?id=2209{ce_token} : pour être redirigé vers un produit spécifique où 2209 représente l'id de l'offre voyage", 512), [
                      [_vShow, form.value.itemType === '4']
                    ]),
                    _withDirectives(_createElementVNode("label", _hoisted_22, "https://app.club-employes.com/voyage{ce_token} : pour être redirigé vers la page d'accueil de voyage", 512), [
                      [_vShow, form.value.itemType === '4']
                    ]),
                    (form.value.itemType === '3')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_23, "Mot(s) recherché(s)"))
                      : _createCommentVNode("", true),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "itemValue",
                      modelValue: form.value.itemValue,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.itemValue) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_FormKit, {
                      type: "hidden",
                      name: "middleMenu",
                      modelValue: form.value.middleMenu,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.middleMenu) = $event)),
                      label: "middleMenu"
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_24, [
                      (loading.value === false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createVNode(_component_FormKit, {
                              type: "submit",
                              label: submitBtnLabel,
                              class: _normalizeClass({ 'btn-primary': true, 'btn-block': true })
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_FormKit, {
                        type: "button",
                        label: "Annuler",
                        onClick: onCancel,
                        class: _normalizeClass({ 'btn-secondary': true, 'btn-block': true })
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["model"])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})